import { BaseAction } from "../../../core/actions/BaseAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { uuid } from "../../../core/utils/Uuid";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import { determineDefaultAge, determinePassengerType, determinePassengerTypeFromPassenger, getPassengerCard } from "../../../Lib/Utils/validationUtil";
import { updateRecoilStateWithType } from "../../../Orchestrator/Recoils/Events/Recoil";
import { PassengerPrmNeedTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IPassenger } from "../../../Orchestrator/Types/Index";
import {
  ICMSBookNowParams,
} from "../../../Orchestrator/Types/Interface/ICmsDestination";
import { showNotification } from "../../../Services/notificationService";
import { getSearchResultAction } from "../../LogicActions/Search/GetSearchResultAction";
import { updateSearchDataForResumeAction } from "../../UIActions/Search/UpdateSearchDataForResumeAction";
import { IPassBooking } from "../../../Orchestrator/Types/Types/BookingTypes";

export interface IPassOfferBookingNowActionParams extends ICMSBookNowParams {
  passBooking?: IPassBooking;
}

class PassOfferBookNowAction extends BaseAction<void, IPassOfferBookingNowActionParams> {
  override async run(): Promise<void | null> {
    if (this.params) {
      const { search, passBooking } = this.params;

      if (!search?.origin || !search?.destination) {
        showNotification("error", getTranslatedMessage('selectOriginDestination'), "");
      } else {
        const passengerExternalRef = uuid();
        let selectedTripPassenger: IPassenger[] = [];
        if (passBooking && passBooking.booking && passBooking?.travelAccount?.travelAccount?.number) {
          const passengerType = determinePassengerTypeFromPassenger(passBooking?.booking?.booking?.passengers?.[0]);
          search.passengerCounts = {
            [passengerType]: 1
          }
          search.totalPassengerCount = 1;

          const travelAccount = passBooking.travelAccount.travelAccount;
          selectedTripPassenger = [{
            "externalRef": passengerExternalRef,
            age: determineDefaultAge(passengerType),
            "type": "PERSON",
            "cards": [
              ...getPassengerCard(passengerType),
            ],
            prmNeeds: passengerType === "wheelchair" ? [PassengerPrmNeedTypeEnum.Wheelchair] : [],
            detail: {
              firstName: travelAccount.holder.firstName,
              lastName: travelAccount.holder.lastName,
              email: "",
              age: 0
            },
            id: ""
          }]
        }

        updateRecoilStateWithType("appliedPassengerPassAtom", {
          outbound: passBooking ? [{
            externalRef: passengerExternalRef,
            passOffer: passBooking
          }] : [],
          inbound: []
        })

        await getSearchResultAction.setParams({
          ...search,
          ...(selectedTripPassenger.length ? { selectedTripPassenger } : {}),
          isPassBookingFlow: true
        });
        await getSearchResultAction.execute();
        if (getSearchResultAction.status.executionStatus == ExecutionStatus.SUCCESS) {
          const result = getSearchResultAction.result;

          if (result?.result == "true") {
            //Update searchStateAtom from Resume Search Data
            updateSearchDataForResumeAction.setParams({ ...search });
            await updateSearchDataForResumeAction.execute();
            localStorage.setItem("resumeSearch", JSON.stringify(search))

            // Set flag to identify user come from destination detail page
            sessionStorage.setItem('isFromDestinationDetail', "true")
            _eventBus.emit({
              eventName: "FLOW_CLOSE",
              data: `OffersFlow`,
            });
            _eventBus.emit({
              eventName: "FLOW_CHANGE",
              data: "MainBookingFlow",
            });
            _eventBus.emit({
              eventName: "ROUTE_CHANGE",
              data: "/train-offer",
            });
          }
        }
      }
    }
  }
}

export const passOfferBookNowAction = new PassOfferBookNowAction();
